import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { SandboxOutcomeFormData } from '../types';
import useSandboxOutcomeOptions from '../use-sandbox-outcome-options';
import SimulatedOutcomes from './simulated-outcomes';
type IdDocOutcomeSelectProps = {
  allowRealOutcome?: boolean;
};
const IdDocOutcomeSelect = t0 => {
  const $ = _c(15);
  const {
    allowRealOutcome
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "sandboxOutcome.id-doc-outcome"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "docVerificationOutcome"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const docVerificationOutcome = useWatch(t2);
  const {
    idDocVerificationOptions
  } = useSandboxOutcomeOptions();
  let t3;
  if ($[2] !== idDocVerificationOptions) {
    t3 = idDocVerificationOptions.find(_temp)?.label ?? "";
    $[2] = idDocVerificationOptions;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const simulatedLabel = t3;
  let t4;
  if ($[4] !== allowRealOutcome || $[5] !== idDocVerificationOptions || $[6] !== simulatedLabel || $[7] !== t) {
    t4 = <div className="flex justify-between items-center">{allowRealOutcome ? <Form.Select name="docVerificationOutcome" label={t(_temp2)} size="compact" options={idDocVerificationOptions} /> : <span className="text-label-2 text-primary">{simulatedLabel}</span>}</div>;
    $[4] = allowRealOutcome;
    $[5] = idDocVerificationOptions;
    $[6] = simulatedLabel;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== docVerificationOutcome || $[10] !== t) {
    t5 = docVerificationOutcome === "real" ? <p className="text-body-2 text-tertiary">{t(_temp3)}</p> : <SimulatedOutcomes />;
    $[9] = docVerificationOutcome;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="flex flex-col gap-4 border-dashed border-tertiary">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default IdDocOutcomeSelect;
function _temp(o) {
  return o.value === "simulated";
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0["real-outcome"].description;
}